import React, { Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from 'components/CustomButtons/Button.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';

import { WithApp } from 'contexts/appContext';
import { Close } from '@material-ui/icons';
import { wsRemove } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';

const useStyles = makeStyles(styles);

export default WithApp(function ButtonDelete(props) {
  const classes = useStyles();
  const { entity, callback, reload, disabled, id, style = {} } = props;

  const [notify, showNotify] = useToasty();
  const [alert, setAlert] = useState(null);

  function confirm() {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de eliminar?"
        onConfirm={() => {
          remove();
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  const hideAlert = () => {
    setAlert(null);
  };

  async function remove() {
    if(callback !== undefined){
      await callback();
      return;
    }

    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      if (!!reload && typeof reload === 'function') {
        reload();
      }
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      {!!disabled ? (
        <Button
          style={style}
          justIcon
          round
          simple
          onClick={confirm}
          color={props.themeContext.buttonColorDanger}
          disabled={props.disabled}
        >
          <Close />
        </Button>
      ) : (
        <Button
          style={style}
          justIcon
          round
          simple
          onClick={confirm}
          color={props.themeContext.buttonColorDanger}
        >
          <Close />
        </Button>
      )}
    </Fragment>
  );
});
